import styled from 'styled-components'

export const IconContainer = styled.div`
  align-items: center; 
  justify-content: center;
  display: flex;
  margin: 0px 10px;
`
